<div class="main-container">
    <div class="mdl-container">
        <div class="d-grid mdl-header">
            <div class="center-svg"><img src="assets/svg/functions-icon.svg" alt=""></div>
            <div><h4 class="text-semibold">Agregar funciones de contacto</h4></div>
            <div><h3 class="color-gray text-semibold"><div class="center-svg"><img (click)="closeMdl();" class="close-button" src="assets/svg/close-icon.svg" alt=""></div></h3></div>
        </div>
        <div class="mdl-body">
            <div class="mt-5">
                @if(step === 0){
                    <div>
                        <ng-select class="crm-ng-select"
                            *ngIf="accounts"
                            [items]="accounts"
                            bindValue="contacto_id"
                            placeholder="Buscar contactos..."
                            [(ngModel)]="selectedAccount"
                            [searchable]="true"
                            [clearable]="true">

                            <ng-template ng-label-tmp let-item="item">
                                {{item.nombre}} {{item.apellido}}
                            </ng-template>

                            <ng-template ng-option-tmp let-item="item">
                                {{item.nombre}} {{item.apellido}}
                            </ng-template>
                        </ng-select>
                    </div>

                    <div class="d-flex flex-row justify-center gap-20 mt-4">
                        <button class="btn btn-primary-outline" (click)="closeMdl()">Cancelar</button>
                        <button class="btn btn-primary" (click)="nextStep()">Siguiente</button>
                    </div>   
                }

                @if(step === 1){
                    <div style="padding: 30px 60px;">
                        <div class="d-grid">
                            <div class="d-grid form-function">
                                <div><b class="color-org">*</b> Nombre Contacto</div>
                                <div><input class="crm-input" type="text" name="" id="" disabled [value]="contactSelected.nombre +' '+ contactSelected.apellido "></div>
                            </div>
                            <div class="d-grid form-function mt-3">
                                <div>Oportunidad</div>
                                <div><input class="crm-input" type="text" name="" id="" disabled value="Negocio Beats"></div>
                            </div>
                            <div class="d-grid form-function mt-3">
                                <div>Función</div>
                                <div>
                                    <select name="" id="" class="crm-input" style="padding: 10px !important;" [(ngModel)]="selectedFunction">
                                        <option value="">Ninguno</option>
                                        @for(item of functions; track item.item){
                                            <option [value]="item.name">{{item.name}}</option>
                                        }
                                    </select>
                                </div>
                            </div>
                            <div class="d-grid form-function mt-3">
                                <div>Principal</div>
                                <div><input type="checkbox" name="" id=""></div>
                            </div>
                        </div>
                        <hr class="mt-5">
                        <div class="d-flex flex-row justify-center gap-20 mt-4">
                            <button class="btn btn-primary-outline" (click)="closeMdl()">Cancelar</button>
                            <button class="btn btn-primary" (click)="saveFunction()">Guardar</button>
                        </div>   
                    </div>
                }
            </div> 
        </div>
    </div>
</div>